export default "__VITE_ASSET__c8f337f0__"